export default __webpack_public_path__ + "static/media/FugitiveEmissions_bg.aff24f9d.jpg";